import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <section className="contact">
      <div className="contact__container">
      <h1 className="contact__title">CONTACT</h1>
        <p className="contact__description">
          For general enquiries, please use the form below and one of our
          dedicated team members will be in touch with you shortly
        </p>
        <p className="contact__text">+1 (732) 723-7033</p>
        <p className="contact__text">mikdashdevelopment@gmail.com</p>
        <p className="contact__text">11234, NY</p>
      </div>
    </section>
  );
}

export default Contact;
